<template>
    <button
        @click="navigateTo(path)"
        class="ml-6 flex items-center duration-300 hover:text-green-500 xl:gap-1 xl:text-sm xl:font-bold"
        :aria-label="ariaLabel">
        <UserCircleIcon class="size-5 stroke-2 lg:size-6" />
        <span v-if="shouldShowName">{{ userCookies ? `Hallo ${userCookies?.firstName}` : '' }}</span>
    </button>
</template>

<script setup lang="ts">
    import { UserCircleIcon } from '@heroicons/vue/24/outline';

    withDefaults(
        defineProps<{
            shouldShowName?: boolean;
        }>(),
        {
            shouldShowName: false,
        },
    );

    const { isLoggedIn, userCookies } = useUserExtended();
    const snippets = useSnippetsStore().snippets;
    const path = computed(() => (isLoggedIn.value ? '/account' : '/login'));

    const ariaLabel = computed(() => {
        if (isLoggedIn.value) {
            snippets['headless.header.toAccount'] ?? 'Naar account';
        }

        return snippets['headless.header.toLogin'] ?? 'Naar login';
    });
</script>
